import { render, staticRenderFns } from "./SergioMartin.vue?vue&type=template&id=163f63cd&scoped=true"
import script from "./SergioMartin.vue?vue&type=script&lang=js"
export * from "./SergioMartin.vue?vue&type=script&lang=js"
import style0 from "./SergioMartin.vue?vue&type=style&index=0&id=163f63cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163f63cd",
  null
  
)

export default component.exports